import { connect } from "react-redux";
import { Nav } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";

import { getCartItemCount } from "../cart/selectors";
import { getOrderCount } from "../orders/selectors";

const Header = ({ cartItemCount, orderCount }) => {
  return (
    <Nav activeKey="/home">
      <Nav.Item>
        <LinkContainer to="/">
          <Nav.Link>Home</Nav.Link>
        </LinkContainer>
      </Nav.Item>
      <Nav.Item>
        <LinkContainer to="/cart">
          <Nav.Link>Cart ({cartItemCount})</Nav.Link>
        </LinkContainer>
      </Nav.Item>
      <Nav.Item>
        <LinkContainer to="/orders">
          <Nav.Link>Orders ({orderCount})</Nav.Link>
        </LinkContainer>
      </Nav.Item>
    </Nav>
  );
};

const mapStateToProps = (state) => {
  return {
    cartItemCount: getCartItemCount(state),
    orderCount: getOrderCount(state),
  };
};

export default connect(mapStateToProps)(Header);
